import React from 'react';
import {ContentWrapper, InfoOriginalNameWrapper, InfoTextWrapper, TextWrapper} from './FolderBasicData.style';
import {t} from 'i18next';
import {formatDate, formatSize} from '../../../utils';
import {StorageObject} from '../../../models/StorageObject';
import {generateIdentifier} from '../../../utils/IdentityUtils';

export interface FolderBasicDataProps {
    readonly language: string;
    readonly item: StorageObject;
}

export const FolderBasicData: React.VFC<FolderBasicDataProps> = (props) => {
    return (
        <ContentWrapper id={generateIdentifier()}>
            <InfoOriginalNameWrapper id={generateIdentifier()}>
                <TextWrapper id={generateIdentifier()}>
                    {t('FOLDER_META_DATA_DIALOG_ORIGINAL_NAME_INFO_TEXT', {name: props.item.name})}
                </TextWrapper>
            </InfoOriginalNameWrapper>
            <InfoTextWrapper id={generateIdentifier()}>
                <TextWrapper id={generateIdentifier()}>
                    {t('FOLDER_META_DATA_DIALOG_FOLDER_COUNT_INFO_TEXT', {count: (props.item.metadata.folderCount ? props.item.metadata.folderCount : 0)})}
                </TextWrapper>
                <TextWrapper id={generateIdentifier()}>
                    {t('FOLDER_META_DATA_DIALOG_FILE_COUNT_INFO_TEXT', {count: (props.item.metadata.fileCount ? props.item.metadata.fileCount : 0)})}
                </TextWrapper>
                <TextWrapper id={generateIdentifier()}>
                    {t('FOLDER_META_DATA_DIALOG_TOTAL_SIZE_INFO_TEXT', {size: formatSize(props.item.totalSize)})}
                </TextWrapper>
            </InfoTextWrapper>
            <div id={generateIdentifier()}/>
            <InfoTextWrapper id={generateIdentifier()}>
                <TextWrapper id={generateIdentifier()}>
                    {t('FOLDER_META_DATA_DIALOG_DATE_CREATED_INFO_TEXT', {date: formatDate(props.language, props.item.metadata.dateCreated)})}
                </TextWrapper>
                <TextWrapper id={generateIdentifier()}>
                    {t('FOLDER_META_DATA_DIALOG_DATE_UPDATED_INFO_TEXT', {date: formatDate(props.language, props.item.metadata.dateUpdated)})}
                </TextWrapper>
            </InfoTextWrapper>
        </ContentWrapper>
    );
};
